<template>
  <el-container class="layout-container">
    <el-aside :width="sidebarWidth" class="sidebar">
      <div class="logo">
        <h2>亲友账簿</h2>
      </div>
      <div class="menu-wrapper">
        <el-menu
          :default-active="activeMenu"
          router
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
        >
        <el-menu-item index="/dashboard">
          <i class="el-icon-data-line"></i>
          <span>数据概览</span>
        </el-menu-item>
        <el-menu-item index="/users">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="/friends">
          <i class="el-icon-user-solid"></i>
          <span>亲友管理</span>
        </el-menu-item>
        <el-menu-item index="/books">
          <i class="el-icon-document"></i>
          <span>账本管理</span>
        </el-menu-item>
        <el-menu-item index="/logs">
          <i class="el-icon-document-copy"></i>
          <span>日志管理</span>
        </el-menu-item>
        <el-menu-item index="/messages">
          <i class="el-icon-bell"></i>
          <span>站内信管理</span>
        </el-menu-item>
        <el-menu-item index="/feedbacks">
          <i class="el-icon-chat-line-square"></i>
          <span>意见反馈管理</span>
        </el-menu-item>
        <el-menu-item index="/user-behavior">
          <i class="el-icon-monitor"></i>
          <span>用户行为监控</span>
        </el-menu-item>
        <el-menu-item index="/gifts">
          <i class="el-icon-present"></i>
          <span>人情往来管理</span>
        </el-menu-item>
        <el-menu-item index="/event-types">
          <i class="el-icon-menu"></i>
          <span>事件类型管理</span>
        </el-menu-item>
        <el-menu-item index="/materials">
          <i class="el-icon-picture"></i>
          <span>素材中心</span>
        </el-menu-item>
        <el-menu-item index="/tongji">
          <i class="el-icon-data-analysis"></i>
          <span>统计管理</span>
        </el-menu-item>
        <el-menu-item index="/daily-text">
          <i class="el-icon-document"></i>
          <span>每日文案管理</span>
        </el-menu-item>
        <el-menu-item index="/changelog">
          <i class="el-icon-document-copy"></i>
          <span>更新日志管理</span>
        </el-menu-item>
        <el-menu-item index="/tarot">
          <i class="el-icon-magic-stick"></i>
          <span>塔罗牌管理</span>
        </el-menu-item>
        <el-menu-item index="/customs">
          <i class="el-icon-place"></i>
          <span>地域礼俗管理</span>
        </el-menu-item>
        <el-menu-item index="/almanac">
          <i class="el-icon-date"></i>
          <span>老黄历管理</span>
        </el-menu-item>
        <el-menu-item index="/login-locations">
          <i class="el-icon-location"></i>
          <span>登录位置管理</span>
        </el-menu-item>
        <el-submenu index="/membership">
          <template slot="title">
            <i class="el-icon-star-on"></i>
            <span>会员管理</span>
          </template>
          <el-menu-item index="/membership-plans">
            <i class="el-icon-goods"></i>
            <span>套餐管理</span>
          </el-menu-item>
          <el-menu-item index="/membership-orders">
            <i class="el-icon-s-order"></i>
            <span>订单管理</span>
          </el-menu-item>
        </el-submenu>
        </el-menu>
      </div>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="header-left">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
              <span v-if="index === breadcrumbList.length - 1">{{ item.title }}</span>
              <router-link v-else :to="item.path">{{ item.title }}</router-link>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <i class="el-icon-user"></i>
              管理员
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',
  provide() {
    return {
      hasBreadcrumb: this.hasBreadcrumb
    }
  },
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    sidebarWidth() {
      return this.isCollapse ? '64px' : '200px'
    },
    breadcrumbList() {
      const breadcrumbList = []
      const currentRoute = this.$route
      
      // 如果是首页，不显示面包屑
      if (currentRoute.path === '/dashboard') {
        return breadcrumbList
      }
      
      // 会员管理的子路由需要显示父级
      if (currentRoute.path === '/membership-plans' || currentRoute.path === '/membership-orders') {
        breadcrumbList.push({
          title: '会员管理',
          path: '#'
        })
      }
      
      // 添加当前路由的标题
      if (currentRoute.meta && currentRoute.meta.title) {
        breadcrumbList.push({
          title: currentRoute.meta.title,
          path: currentRoute.path
        })
      }
      
      return breadcrumbList
    },
    hasBreadcrumb() {
      return this.breadcrumbList.length > 0
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('logout')
        this.$router.push('/login').catch(() => {
          // 静默处理导航错误
        })
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.sidebar {
  background-color: #304156;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  transition: all 0.3s;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #2b3a4a;
  color: #fff;
  flex-shrink: 0;
}

.logo h2 {
  font-size: 18px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.menu-wrapper::-webkit-scrollbar {
  width: 6px;
}

.menu-wrapper::-webkit-scrollbar-track {
  background: #2b3a4a;
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background: #4a5568;
  border-radius: 3px;
}

.menu-wrapper::-webkit-scrollbar-thumb:hover {
  background: #5a6578;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  min-height: 60px;
  height: 60px;
  flex-shrink: 0;
}

.header-left {
  flex: 1;
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  cursor: pointer;
  color: #606266;
}

.main-content {
  background-color: #f0f2f5;
  padding: 0;
  overflow: hidden;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    min-width: 64px;
    max-width: 64px;
  }
  
  .logo h2 {
    font-size: 14px;
  }
  
  .main-content {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 8px;
  }
}
</style>

